import { Component, Inject } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AppService } from 'src/app/services/app/app.service';
import { CommonService } from 'src/app/services/common/common.service';
import { RecruiterService } from 'src/app/services/recruiter/recruiter.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { CourseService } from 'src/app/services/course/course.service';
import { DeleteItemComponent } from '../../delete-item/delete-item.component';

@Component({
  selector: 'app-create-dress-code',
  templateUrl: './create-dress-code.component.html',
  styleUrls: ['./create-dress-code.component.scss']
})
export class CreateDressCodeComponent {

  public selectOptionArrImg: any[] = [
    { val: "", file: null }
  ];

  public addForm!: FormGroup;
  public wagesType!: string;
  private animationConfig: {} = { enterAnimationDuration: '300ms', exitAnimationDuration: "300ms" }
  public isEdit: boolean = false;
  constructor(private fb: FormBuilder, private appService: AppService, private dialogRef: MatDialogRef<CreateDressCodeComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: any, public recruiterService: RecruiterService, private commonService: CommonService,
    public dialog: MatDialog, private spinner: NgxSpinnerService, private courseService: CourseService
  ) { }
  ngOnInit(): void {
    this.addForm = this.fb.group({
      dr_c: ["", Validators.required],
    })
    if (this.dialogData && this.dialogData.isEmployeeSetting) {

    }

    // if the modal is opened to edit the category then set value or else add category
    if (this.dialogData.category_data) {


      this.isEdit = true;
      this.addForm.get('dr_c')?.setValue(this.dialogData.category_data.dr_c)

      // Set existing images
      const existingImages = this.dialogData.category_data.logo_rec || [];



      // Convert each image URL into object for preview
      this.selectOptionArrImg = existingImages.map((item: any) => ({
        val: item.logo,
        file: null,
        id: item.id,
      }));
    }
    else {

    }
  }

  isControlHasError(controlName: string, validationType: string): boolean {
    return this.appService.isControlHasError(this.addForm, controlName, validationType);
  }


  onSubmit() {
    if (this.addForm.invalid) {
      this.addForm.markAllAsTouched();
      return;
    }

    const formData = new FormData();
    formData.append('dr_c', this.addForm.get('dr_c')?.value);

    let hasFile = false;
    // Append each image file
    this.selectOptionArrImg.forEach((item, i) => {
      if (item.file) {
        formData.append('dress_logo[]', item.file); // `[]` if expecting array
        hasFile = true;
      }
    });

    // If editing and no image is present, send empty array
    if (!hasFile && this.isEdit) {
      formData.append('dress_logo[]', '');
    }

    if (this.isEdit && this.dialogData.category_data) {
      formData.append('dress_id', this.dialogData.category_data.id);

      this.recruiterService.editDressCode(formData).subscribe({
        next: (res: any) => {
          if (res.status === 200) this.dialogRef.close();
        },
        error: (err) => {
          console.error('Edit failed', err);
        }
      });

    } else {
      this.recruiterService.createDressCode(formData).subscribe({
        next: (res: any) => {
          if (res.status === 200) this.dialogRef.close();
        },
        error: (err) => {
          console.error('Create failed', err);
        }
      });
    }
  }



  onCancel() {
    this.dialogRef.close();
  }

  onSelect(event, index: number) {
    if (event.addedFiles.length > 0) {
      const file = event.addedFiles[0];

      // Store the file reference
      this.selectOptionArrImg[index].file = file;

      // Optional: for preview
      const reader = new FileReader();
      reader.onload = () => {
        this.selectOptionArrImg[index].val = reader.result as string;
      };
      reader.readAsDataURL(file);
    }
  }


  onImageChange(file: any, index: number) {
    let formData = new FormData();
    formData.append('obj_file', file)

    this.courseService.uploadFile(formData).subscribe((response: any) => {
      if (response.status == 200) {
        this.selectOptionArrImg[index].val = response.msg;
      }
      else {
      }
    })
  }

  // Delete an uploaded image field with animation
  onDeleteItemImg(index: number, id) {
    let objData = {
      api_type: "delete_content",
      content_type: "delete_dress_logo",
      id: id,
      dress_id: this.dialogData.category_data.id
    };
    const dialogRef = this.dialog.open(
      DeleteItemComponent,
      Object.assign({
        data: objData,
      })
    );
    dialogRef.afterClosed().subscribe((result) => {
      if (result && result["delete_content"] == true) {
        this.selectOptionArrImg[index].slideOut = true;
        setTimeout(() => {
          this.selectOptionArrImg.splice(index, 1);
        }, 300);
      }
    });
  }

  onAddItemImg() {
    this.selectOptionArrImg.push({
      val: ""      // Store preview image URL
    });
  }


}
